import { createFileRoute } from "@tanstack/react-router";
import Articulos from "@/pages/Articulos";

export const Route = createFileRoute("/articulos/")({
  head: () => ({
    meta: [
      { title: "Artículos sobre Lotería Nicaragua y Costa Rica | TiemposHoy" },
      {
        name: "description",
        content:
          "Guías, consejos y todo lo que necesitas saber sobre la Diaria Loto de Nicaragua y los Tiempos JPS de Costa Rica.",
      },
      { name: "keywords", content: "artículos lotería, guía diaria loto, guía tiempos jps, consejos lotería" },
      { property: "og:title", content: "Artículos sobre Lotería Nicaragua y Costa Rica | TiemposHoy" },
      { property: "og:description", content: "Guías, consejos y todo lo que necesitas saber sobre la Diaria Loto de Nicaragua y los Tiempos JPS de Costa Rica." },
      { name: "twitter:card", content: "summary" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://tiemposhoy.com/articulos" },
    ],
    links: [{ rel: "canonical", href: "https://tiemposhoy.com/articulos" }],
  }),
  component: Articulos,
});
